import React, { useState } from "react";
import Header from "../../layouts/Header";
import { Col, Row } from "react-bootstrap";
import axios from "axios";
import { CHAT_API_URL } from "../../redux/constants/type";
import { useDispatch } from "react-redux";
import { TextField } from "@mui/material";

const getUnit = (unit) => {
  switch (unit) {
    case "millimeter":
      return "+mm";
    default:
      return "";
  }
};

// documentId: "0a05531ad17eb485096fb443",
// workSpaceId: "8086e69d2eb2a7358339de66",
// elementId: "3fdf5bb3f7ae246db9a61cad"
const InterkoPage = () => {
  const [data, setData] = useState(null);
  const [tblConfiguration, setTableConfiguration] = useState({
    headers: [],
    columns: [],
  });
  const [changedConfiguration, setChangedConfiguration] = useState([]);
  const [configIsLoading, setConfigLoading] = useState(false);
  const [bomIsLoading, setBomLoading] = useState(false);
  const [baseRequest, setBaseRequest] = useState({
    documentId: "",
    workSpaceId: "",
    elementId: "",
  });
  const [errors, setErrors] = useState({ configuration: null, bom: null });

  const handleClickPreviewBOM = () => {
    if (!bomIsLoading) {
      setBomLoading(true);
      setData(null);
      setErrors({ configuration: errors.configuration, bom: null });
      let strConfiguration = [];
      changedConfiguration.forEach((item) => {
        const unit = getUnit(item.unit);
        strConfiguration.push(`${item.key}=${item.value}${unit}`);
      });
      let payload = { ...baseRequest };
      payload.other = {
        configuration:
          strConfiguration.length > 0 ? strConfiguration.join(";") : "cuurent",
      };
      axios
        .post(`${CHAT_API_URL}/api/User/GetInterkoBOMDetails`, payload)
        .then((res) => {
          setData(res.data);
          setBomLoading(false);
          setErrors({ configuration: errors.configuration, bom: null });
        })
        .catch((error) => {
          setBomLoading(false);
          setErrors({
            configuration: errors.configuration,
            bom: error?.response?.data?.message || "Api error.",
          });
        });
    }
  };

  const fetchModelConfiguration = () => {
    if (!configIsLoading) {
      setConfigLoading(true);
      setChangedConfiguration([]);
      setTableConfiguration({ headers: [], columns: [] });
      setErrors({ bom: errors.bom, configuration: null });
      axios
        .post(`${CHAT_API_URL}/api/User/GetInterkoConfiguration`, baseRequest)
        .then((res) => {
          const finalData = res.data;
          const headers = [];
          const columns = [];
          finalData.configurationParameters.forEach((item) => {
            headers.push(item.parameterName);
            columns.push({
              parameterName: item.parameterName,
              parameterId: item.parameterId,
              defaultValue: item.rangeAndDefault
                ? item.rangeAndDefault.defaultValue
                : item.defaultValue,
              value: item.rangeAndDefault
                ? item.rangeAndDefault.defaultValue
                : item.defaultValue,
              unit: item.rangeAndDefault ? item.rangeAndDefault.units : "",
            });
          });
          setTableConfiguration({ headers, columns });
          setConfigLoading(false);
          setErrors({ bom: errors.bom, configuration: null });
        })
        .catch((error) => {
          setConfigLoading(false);
          setErrors({
            bom: errors.bom,
            configuration: error?.response?.data?.message || "Api error.",
          });
        });
    }
  };

  const handleInputChange = (e, index) => {
    let oldConfig = [...changedConfiguration];
    const newValue = e.target.value;
    let old = { ...tblConfiguration };
    old.columns[index].value = newValue;
    if (old.columns[index].defaultValue != newValue) {
      let itemIndex = oldConfig.findIndex(
        (x) => x.key === old.columns[index].parameterId
      );
      if (itemIndex > -1) {
        oldConfig[itemIndex].value = newValue;
      } else {
        oldConfig.push({
          key: old.columns[index].parameterId,
          value: newValue,
          unit: old.columns[index].unit,
        });
      }
    } else {
      let itemIndex = oldConfig.findIndex(
        (x) => x.key === old.columns[index].parameterId
      );
      if (itemIndex > -1) {
        oldConfig.splice(itemIndex, 1);
      }
    }
    setTableConfiguration({ ...old });
    setChangedConfiguration([...oldConfig]);
  };

  const handleBaseFormChange = (value, name) => {
    let old = { ...baseRequest };
    old[name] = value;
    setBaseRequest({ ...old });
  };

  return (
    <>
      <Header />
      <div className="container">
        <div className="parent">
          <div className="outer">
            <Row>
              <Col xl={12} className="p-2">
                <div className="fw-bold mt-2 Contact-heading">Interko</div>
              </Col>
              <Col xl={12} className="p-2">
                <Row>
                  <Col xs={3}>
                    <TextField
                      label="Document Id"
                      fullWidth
                      value={baseRequest.documentId}
                      onChange={(e) =>
                        handleBaseFormChange(e.target.value, "documentId")
                      }
                    />
                  </Col>
                  <Col xs={3}>
                    <TextField
                      label="Workspace Id"
                      fullWidth
                      value={baseRequest.workSpaceId}
                      onChange={(e) =>
                        handleBaseFormChange(e.target.value, "workSpaceId")
                      }
                    />
                  </Col>
                  <Col xs={3}>
                    <TextField
                      label="Element Id"
                      fullWidth
                      value={baseRequest.elementId}
                      onChange={(e) =>
                        handleBaseFormChange(e.target.value, "elementId")
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={12} className="p-2">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fw-bold mt-2 fs-5">Current Configuration</div>
                  <div>
                    {errors.configuration && (
                      <span className="text-danger me-2">
                        {errors.configuration}
                      </span>
                    )}
                    {configIsLoading && (
                      <span>Loading...&nbsp;&nbsp;&nbsp;</span>
                    )}
                    <button
                      className="btn add-member-btn"
                      onClick={fetchModelConfiguration}>
                      <div className="add-member-text">Fetch</div>
                    </button>
                  </div>
                </div>
              </Col>
              <Col xl={12} className="p-2">
                <div
                  className="table-responsive"
                  style={{
                    backgroundColor: "#FFFFFF",
                    boxShadow: "3px 5px 10px #3B45581A",
                    borderRadius: "8px",
                  }}>
                  <table className="table table-bordered mb-0">
                    <thead className="thead-dark">
                      <tr>
                        {tblConfiguration?.headers.map((item, index) => (
                          <th key={`th-con-${index}`}>{item}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {tblConfiguration?.columns.map((item, index) => (
                          <td key={`td-con-${index}`}>
                            <input
                              type="text"
                              value={item.value}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col
                xl={12}
                className="p-2"
                style={{ borderTop: "1px solid #f1f1f1" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fw-bold mt-2 fs-5">BOM</div>
                  <div>
                    {errors.bom && (
                      <span className="text-danger me-2">{errors.bom}</span>
                    )}
                    {bomIsLoading && <span>Loading...&nbsp;&nbsp;&nbsp;</span>}
                    <button
                      className="btn add-member-btn"
                      onClick={handleClickPreviewBOM}>
                      <div className="add-member-text">Refresh</div>
                    </button>
                  </div>
                </div>
              </Col>
              {!bomIsLoading && Boolean(data) && (
                <Col xl={12} className="p-2">
                  <div
                    className="table-responsive"
                    style={{
                      backgroundColor: "#FFFFFF",
                      boxShadow: "3px 5px 10px #3B45581A",
                      borderRadius: "8px",
                    }}>
                    <table className="table mb-0">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Part number</th>
                          <th>Revision</th>
                          <th>Name</th>
                          <th>Quntity</th>
                          <th>Baan ID</th>
                          <th>Metrial</th>
                          <th>Description</th>
                          <th>Mass</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.rows?.map((row, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "5ace8269c046ad612c65a0ba"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "57f3fb8efa3416c06701d60f"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "57f3fb8efa3416c06701d610"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "57f3fb8efa3416c06701d60d"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "5ace84d3c046ad611c65a0dd"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "62967111df8366391940b66d"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                    "57f3fb8efa3416c06701d615"
                                  ].displayName
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "57f3fb8efa3416c06701d60e"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  row.headerIdToValue[
                                  "57f3fb8efa3416c06701d626"
                                  ]
                                }
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterkoPage;
